export function createSlackAttachments(text, color = '#D00000', title, value) {
    return({
        'channel': 'upgrade_requests',
        'username': 'Truckster Vendor',
        'attachments': [
            {
                'fallback': text,
                'pretext': text,
                'color': color,
                'fields': [
                    {
                        title,
                        value,
                        'short': false
                    }
                ]
            }
        ]
    });
}

export default function sendSlackMessage(attachments = null, webHookLink = 'https://hooks.slack.com/services/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') {
    return new Promise((resolve) => {
        fetch(webHookLink, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            body: JSON.stringify(attachments)
        })
            .then(() => resolve('Done'))
            .catch((error) => {
                console.log('[FAILED] POST MESSAGE TO SLACK', error);
                resolve(error.message);
            });
    });
}

export function sendSlackMessageSimple(hookLink = '', title, body) {
    if (!hookLink) return Promise.reject('No Webhook Link');

    return new Promise((resolve) => {
        fetch(hookLink, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            body: JSON.stringify({
                'text': title,
                'blocks': [
                    {
                        'type': 'section',
                        'text': {
                            'type': 'mrkdwn',
                            'text': `${title}\n`
                        }
                    },
                    { 'type': 'divider' },
                    {
                        'type': 'section',
                        'text': {
                            'type': 'mrkdwn',
                            'text': `${body}`
                        }
                    }
                ]
            })
        })
            .then(() => resolve('Done'))
            .catch((error) => {
                console.log('[FAILED] POST MESSAGE TO SLACK', error);
                resolve(error.message);
            });
    });
}
